var React = require('react');

function LineChart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1920 1536v128H-128V128H0v1408h1920zM1792 288v435q0 21-19.5 29.5T1737 745l-121-121-633 633q-10 10-23 10t-23-10l-233-233-416 416-192-192 585-585q10-10 23-10t23 10l233 233 464-464-121-121q-16-16-7.5-35.5T1325 256h435q14 0 23 9t9 23z"}));
}

LineChart.defaultProps = {"width":"1792","height":"1792","viewBox":"0 0 1792 1792"};

module.exports = LineChart;

LineChart.default = LineChart;
